<template>
  <div class="cmp-settings-user dt-page">
    <v-layout
      v-if="!authenticated"
      class="needcred-form-container login-white"
      row
      wrap
    >
      <LoginForm :loginFormData="loginFormData" @change="onLoginUserChange" />
    </v-layout>
    <v-layout row wrap v-if="authenticated">
    
    
      <!-- <div class="dt-tabs-container submodule-root">
        <glayout :tabs="[]" tabPanelColor="secondary">
          <gtab>
            <grow>
              <gcol>
                <gbox
                  :h="
                    boxHeight(
                      userlist && userlist.all_user && userlist.all_user.length
                    )
                  "
                  :title="$t('users')"
                >
                  <Users
                    @add_click="onAddUserClick"
                    @onUserItemClick="onUserItemClick"
                    :userList="userlist"
                    @onUserDelete="onUserDelete"
                    @onTextInputBlur="onTextInputBlur"
                  />
                </gbox>
              </gcol>
            </grow>
          </gtab>
        
        </glayout>
      </div> -->

      <div class="user-list-table-container">
        <Users
          @add_click="onAddUserClick"
          @onUserItemClick="onUserItemClick"
          :userList="userlist"
          :loadingFlag="loadingFlag"
          @onUserDelete="onUserDelete"
          @onTextInputBlur="onTextInputBlur"
        />
        <!-- <NTable
          class="user-list-table h1"
          :config="tableConfig"
          :headers="headers"
          :items="list"
          :id="'settings-users-user_list'"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr :title="item.fullname">
              <td @click="onUserItemClick(item)" v-bind="tdcon('users')">
                <span> {{ item["user_name"] }} </span>
              </td>
              <td v-bind="tdcon('fullname')">
                <input
                  type="text"
                  class="dbox-table--textfield"
                  name="staff_fullname"
                  :id="item.user_id + 'staff_fullname'"
                  :value="item['staff_fullname']"
                  v-on:blur="(e) => onTextInputBlur(e, 'staff_fullname', item)"
                />
              </td>
              <td v-bind="tdcon('phone1')">
                <input
                  type="text"
                  class="dbox-table--textfield"
                  name="staff_phone1"
                  :id="item.user_id + 'staff_phone1'"
                  :value="item['staff_phone1']"
                  v-on:blur="(e) => onTextInputBlur(e, 'staff_phone1', item)"
                />
              </td>
              <td v-bind="tdcon('phone2')">
                <input
                  type="text"
                  class="dbox-table--textfield"
                  name="staff_phone2"
                  :id="item.user_id + 'staff_phone2'"
                  :value="item['staff_phone2']"
                  v-on:blur="(e) => onTextInputBlur(e, 'staff_phone2', item)"
                />
              </td>
              <td v-bind="tdcon('email_1')">
                <input
                  type="text"
                  class="dbox-table--textfield"
                  name="staff_email"
                  :id="item.user_id + 'staff_email'"
                  :value="item['staff_email']"
                  v-on:blur="(e) => onTextInputBlur(e, 'staff_email', item)"
                />
              </td>
              <td v-bind="tdcon('cost')">
                <span
                  >{{ item["user_cost"] }}
                  {{ $store.getters.account.client.default_currency }}</span
                >
              </td>
              <td v-bind="tdcon('options')">
                <img
                  @click.stop="(e) => onUserDelete(item)"
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s2"
                  alt="Delete User"
                  title="Delete User"
                />
              </td>
            </tr>
          </template>
        </NTable> -->
      </div>
    </v-layout>
    <Sidewindow :value="userDetailsFlag" @closed="onUserSidewindowClose">
      <UserSidewindow />
    </Sidewindow>
    <ModalContainer
      v-if="authenticated"
      :modalKey="'createUser'"
      :width="'small'"
      @cancelled="onHideComponentModal"
    >
      <CreateUser @added="onNewUserAdded" @cancelled="onHideComponentModal" />
    </ModalContainer>
    <ModalContainer
      v-if="authenticated"
      :modalKey="'createExternalUser'"
      :width="'small'"
      @cancelled="onHideComponentModal"
    >
      <CreateExternalUser
        @added="onExternalUserAdded"
        @cancelled="onHideComponentModal"
      />
    </ModalContainer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import UserSidewindow from "./user-sidewindow";
import Sidewindow from "@dtplugins/sidewindow/sidewindow";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { handleFromRoute } from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";

import { mapKeyToAction } from "../../../../store/global";

import {
  userListLDTRoutes,
  getUserDetailsSelectable,
  childOfOrEqualDetails,
  externalUserListLDTRoutes,
} from "../../router/routes";

import LoginForm from "../../../../dt-plugins/login/login-form";
import CreateUser from "./create-user";
import CreateExternalUser from "./create-external-user.vue";
import ExternalUsers from "./external-user-list.vue";
import Users from "./users.vue";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createNeedCredential } from "../../../../dt-plugins/credential/need-credential";
import { createTableHeader } from "../../../../plugins/datatable";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
const listLength = 30;

const LDTConfig = {
  entityName: "user",
  ldtRoutes: userListLDTRoutes,
  detailsSelectableFunction: getUserDetailsSelectable,
  primaryKey: "user_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.SelectedUser.SET.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.SelectedUser.SET.SINGLE,
};

export default {
  components: {
    NTable,
    UserSidewindow,
    LoginForm,
    Sidewindow,
    CreateUser,
    CreateExternalUser,
    ModalContainer,
    ExternalUsers,
    Users,
  },
  mounted: async function () {},
  data: function () {
    return {
      defaultConfig: defaultConfig,
      isExternalUserList: false,
      activeTabIndex: 0,
      username: "",
      password: "",

      // tableConfig: createNTableConfig({
      //   fullHeight: true,
      // }),

      authenticated: false,


      loadingFlag: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createLDTHost({
      entityName: "user",
      ldtRoutes: userListLDTRoutes,
      detailsSelectableFunction: getUserDetailsSelectable,
      primaryKey: "user_id",
      storeNs: storeNS,
      SELECT_ACTION: ActionTypes.UserDetails.FETCH.SINGLE,
      SELECT_AUTO_ACTION: ActionTypes.SELECT_USER_AUTO,
    }),
    createModalMixin("createUser"),
    createModalMixin("createExternalUser"),
    createNeedCredential(),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        console.log("to", to);
        this.isExternalUserList =
          to.query["external"] == "true" || to.query["external"] == true
            ? true
            : false;
        this.activeTabIndex = this.isExternalUserList ? "1" : "0";
      },
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      userlist: "userlist",
      systemLanguagesTV: "systemLanguagesTV",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    headers: function () {
      return this.isExternalUserList
        ? [
            createTableHeader("users", { text: "External User" }),
            createTableHeader("fullname"),
            createTableHeader("language"),
            createTableHeader("email_1"),
            createTableHeader("options", { text: false, f: 0.2 }),
          ]
        : [
            createTableHeader("users"),
            createTableHeader("fullname"),
            createTableHeader("phone1"),
            createTableHeader("phone2"),
            createTableHeader("email_1"),
            createTableHeader("cost", { ta: "right" }),
            createTableHeader("options", { text: false, f: 0.2 }),
          ];
    },
    userDetailsFlag: function () {
      return childOfOrEqualDetails(this.$route);
    },
    list: function () {
      if (this.isExternalUserList) {
        return this.userlist.ext_users;
      } else {
        return this.$store?.getters?.account?.user?.user_name ==
          "details_helper"
          ? this.userlist.all_user
          : this.userlist.all_user.filter(
              (e) => e.user_name != "details_helper"
            );
      }
    },
    userSettingsTabs: function () {
      return [
        {
          route: "users",
          value: this.$t("users"),
        },
        {
          route: "external_user",
          value: this.$t("tab_title_external_users"),
        },
      ];
    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.Users.FETCH.ALL,
      ActionTypes.Users.UPDATE.SINGLE,
      ActionTypes.Users.INSERT.SINGLE,
      ActionTypes.Users.DELETE.SINGLE,
    ]),
    tabSelectedRouting: function (tabId) {
      this.$router.push({
        name: "users",
        params: {
          tab: tabId,
        },
      });
    },
    fetchList: async function () {
      this.loadingFlag = true;
      await this[ActionTypes.Users.FETCH.ALL]({
        username: this.username,
        password: this.password,
      });
      this.loadingFlag = false;
    },

    refresh() {
      this.fetchList();
    },
    onExternalUserDelete: async function (item) {
      const { external_user_id } = item;

      const confirmationResult = await confirmDelete(
        "External User",
        item.given_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ExternalUsers.DELETE.SINGLE](external_user_id);
      }
    },
    onUserDelete: async function (item) {
      const { user_id } = item;

      const confirmationResult = await confirmDelete(
        "User",
        item.staff_fullname
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.Users.DELETE.SINGLE](user_id);
      }
    },

    onUserItemClick: function (item) {
      const { user_id } = item;
      this.$router.push({
        name: userListLDTRoutes.names.tab,
        params: {
          user_id,
          tab: "overview",
        },
      });
    },
    onExternalUserItemClick: function (item) {
      const { user_id } = item;
      this.$router.push({
        name: userListLDTRoutes.names.tab,
        params: {
          user_id,
          tab: "overview",
        },
        query: {
          external: true,
        },
      });
    },

    onTextInputBlur: function ({ value, name, item }) {
      this[ActionTypes.Users.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onExternalTextInputBlur: function ({ value, name, item }) {
      this[ActionTypes.ExternalUsers.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onUserSidewindowClose: function () {
      this.$router.push({
        name: userListLDTRoutes.names.list,
      });
    },
    onAddUserClick: function (e) {
      openModalRoute(this, e);
    },
    onHideComponentModal: function () {
      closeModalRoute(this);
    },
    onExternalUserAdded: function (user) {
      this[ActionTypes.ExternalUsers.INSERT.SINGLE](user);
      this.onHideComponentModal();
    },
    onNewUserAdded: function (user) {
      this[ActionTypes.Users.INSERT.SINGLE](user);
      this.onHideComponentModal();
    },

    onExternalUserSelected: function () {},
    onSelectTab: function (tab) {
      console.log("tab", tab);
      if (tab.route === "users") {
        this.$router.push({
          query: {
            external: undefined,
          },
        });
      } else {
        this.$router.push({
          query: {
            external: true,
          },
        });
      }
    },
    //MARK: Method
  },
};
</script>

<style lang="scss">
.cmp-settings-user {
  .dt-grid-layout {
    height: calc(100vh - 108px);
    // padding-bottom: 10px;
    // .dt-grid-tab{
    //   height: 100%;
    //   .dt-grid-tab--body{
    //     height: 100%;
    //     .ut-fc{
    //       height: 100% !important;
    //     }
    //   }
    // }
  }
  .dt-page--top-bar {
    .dt-tabs-container {
      margin-left: 20px;
      background: none;
      margin-bottom: 6px;
      .tabs__container {
        background: none !important;
      }
    }
  }

  .dt-ntable {
    --ntable-height: calc(100vh - 130px);
    td:first-child {
      font-weight: 700;
      color: black;
      &:hover {
        text-decoration: underline;
      }
    }
    th:nth-child(6),
    td:nth-child(6) {
      //flex: 0.2;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      th:nth-child(4),
      td:nth-child(4) {
        display: none;
      }
      th:nth-child(6),
      td:nth-child(6) {
        flex: 0.6;
      }
    }
  }
}
</style>
